import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PolicyTermService } from '@services/policy-term.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class FooterComponent {

  constructor(private readonly policyService: PolicyTermService) { }

  openPrivacyPolicy() {
    this.policyService.openPrivacyPolicy();
  }
}
